const formatClubName = (clubName: string | null | undefined): string => {
  if (!clubName) return "Unknown"

  const words = clubName.split(" ")
  const formattedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  return formattedWords.join(" ")
}

export default formatClubName
